/**
 * Item active cooldown fidelity (match time in seconds).
 */

export function applyActiveCooldown(item, now, cooldownMs) {
  if (!item || !(cooldownMs > 0)) return;
  item.activeReadyAt = now + cooldownMs / 1000;
}

export function getActiveCooldownRemaining(item, now) {
  if (!item || typeof item.activeReadyAt !== 'number') return 0;
  if (typeof now !== 'number' || !Number.isFinite(now) || now < 0) return 0;
  const rem = item.activeReadyAt - now;
  if (!Number.isFinite(rem)) return 0;
  return Math.round(Math.max(0, rem) * 10) / 10;
}

export function isActiveReady(item, now) {
  return getActiveCooldownRemaining(item, now) <= 0;
}
